import { sendReplyHandler } from './messages';
import { MESSAGE_TYPES } from '../constants';

// taken from: https://github.com/aws-amplify/amplify-js/blob/66bfe312f300fd6ca1bc756ab01690d36f337af9/packages/amazon-cognito-identity-js/src/StorageHelper.js
let dataMemory = {};
const sendReply = ({ type, payload }) => {
  sendReplyHandler(self)({ type, payload, metadata: { topic: null } });
};

/** @class */
export class MemoryStorage {
  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  static setItem(key, value) {
    dataMemory[key] = value;
    sendReply({ type: MESSAGE_TYPES.MEMORY_STORAGE_SET_ITEM, payload: { key, value } });
    return dataMemory[key];
  }

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */
  static getItem(key) {
    return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
  }

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */
  static removeItem(key) {
    sendReply({ type: MESSAGE_TYPES.MEMORY_STORAGE_REMOVE_ITEM, payload: { key } });
    return delete dataMemory[key];
  }

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */
  static clear() {
    dataMemory = {};
    sendReply({ type: MESSAGE_TYPES.MEMORY_STORAGE_CLEAR });
    return dataMemory;
  }
}
